import Vue from "vue"
import VueRouter from "vue-router"
import util from "@/assets/util"

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
	return originalPush.call(this, location).catch((err) => err)
}

const routeMap = {
	"/courseHome": "../views/cultural/CourseHome",
	"/courseHistory": "../views/course/CourseHistory",
	"/home": "../views/HomeView",
	"/login": "../views/login/Login",
	"/articles": "../views/ArticleList",
	"/article": "../views/Article",
	"/policys": "../views/PolicyList",
	"/policy": "../views/Policy",
	// "/my": "../views/My",
	"/my": {
		"/": "../views/my/My",
		myTask: "../views/my/MyTask",
		myMsg: "../views/my/MyMsg",
		myAction: "../views/my/MyAction",
		myCourse: "../views/my/MyCourse",
		myLearningRecord: "../views/my/MyLearningRecord",
		myPointsRecord: "../views/my/MyPointsRecord",
		userInfo: "../views/my/UserInfo",
		orderInfo: "../views/my/OrderInfo",
	},
	"/study": {
		"/": "../views/study/Index",
		studyProgress: "../views/study/StudyProgress",
		studyCurse: "../views/study/StudyCurse",
		studyExam: "../views/study/StudyExam",
		studyExamResult: "../views/study/StudyExamResult",
		feedback: "../views/study/Feedback",
		rankingList: "../views/study/RankingList",
	},
	"/course": {
		courseList: "../views/course/CourseList",
		application: "../views/course/Application",
		detail: "../views/course/Detail",
		courseHome: "../views/course/CourseHome",
		courseDetail: "../views/course/CourseDetail",
		coursePrice: "../views/course/CoursePrice",
		courseHistory: "../views/course/CourseHistory",
	},
	"/": {
		redirect: "/courseHome",
	},
}
const routes = util.convertRouteMap(routeMap, function (module) {
	if (module.startsWith("../")) {
		return import(`../${module.substr(3)}`)
	}
	return import(`${module}`)
})
const router = new VueRouter({
	routes,
})

// router.beforeEach((to, from, next) => {
// 	let token = sessionStorage.getItem("SAuthToken")
// 	if (
// 		(!token || token == "" || token == undefined) &&
// 		to.fullPath != "/login" &&
// 		!sessionStorage.getItem("wxwork")
// 	) {
// 		next({ path: "/login" })
// 	} else {
// 		next()
// 	}
// })

export default router
